<template>
    <!-- SearchBar -->
    <inputComboBox2 ref="inputBarRef" placeholder="Rechercher ..." v-model="inputBarContent">
      <template #dropd>
        <refSheetList @close="closeDropDown()"/>
      </template>
    </inputComboBox2>

    <!-- Search Engines: medical & medication -->
    <div class="row gap-04 mtop-06 w-full">
      <template v-for="(item, index) in searchEngines" :key="index">
        <buttonGroup class="rowcenter" @click="searchFCT(item)">
          <div class="item-m">
            <img :src="item.logoImage" alt="Logo" style="width: 100%; height: 100%;">
          </div>
        </buttonGroup>
      </template>
      <div class="mleft-25"/>
      <template v-for="(item, index) in medicSearchEngines" :key="index">
        <buttonGroup class="rowcenter" @click="searchFCT(item)">
          <div class="item-m">
            <img :src="item.logoImage" alt="Logo" style="width: 100%; height: 100%;">
          </div>
        </buttonGroup>
      </template>
      <!-- Right Buttons -->
      <div class="row gap-04" style="margin-left: auto;">
        <!-- Download -->
        <buttonGroup v-if="localFileBlob" @click="downloadFile()">
          <svg-item icon="download" styles="size-m main-m"/>  
        </buttonGroup>
        <!-- Print -->
        <buttonGroup v-if="['Pdf', 'Image'].includes(uiStore.referenceFile?.fileType) && localFileBlob" @click="printFile()">
          <svg-item icon="printer" styles="size-m main-m"/> 
        </buttonGroup>
        <!-- FullScreen -->
        <buttonGroup v-if="iFramePath" style="margin-top: -0.3rem; margin-bottom: -0.4rem; margin-right: -0.2rem;" @click="fullScreen()">
          <svg-item icon="fullScreen" styles="size-l main-m"/>
        </buttonGroup> 
      </div>

    </div>

    <!-- iFrame -->
    <div v-if="iFramePath" class="w-full">
      <div class="mtop-10 w-full shadow" style="height: 84.5vh; overflow: hidden;">
        <iframe ref="iFrameRef" :src="iFramePath" scrolling="true" frameborder="0" style="height: 115%; width: 115%; transform: scale(0.87); transform-origin: top left;"></iframe>
      </div>
    </div>

</template>




<script setup>
import refSheetList from './refSheetList.vue'

import { ref, watch } from 'vue'
import { searchEngines, medicSearchEngines, getSearchEnginePath, getDefaultSearchEngine }  from '@/functions/externalReference'
import gen from "@/functions/general.js"
import appuserapi from "@/api/appuserapi"
import { useUiStore } from '@/stores/ui'
const uiStore = useUiStore()
const inputBarRef = ref(null)
const iFrameRef = ref(null)


function closeDropDown() {
  console.log("closeDropDown2")
  inputBarRef.value.hideDropdown()
}

// I-FRAME
const localFileBlob = ref(null)
const iFramePath = ref("")

async function setIframePath() {
  //Clear
  localFileBlob.value = null
  iFramePath.value = null
  //Update
  const referenceUrl = uiStore.referenceIFramePath
  if (uiStore.referenceFile) {
    getReferenceFile()
  } else if (referenceUrl) {
    iFramePath.value = referenceUrl
  }
}

async function getReferenceFile() {
  const referenceFileId = uiStore.referenceFile.appUserResultReferenceFileId.toString()
  //API
  const respBlob = await appuserapi.getAppUserReferenceFileStream(referenceFileId)
  //Fill
  localFileBlob.value = respBlob
  const myBlob = new Blob([respBlob], {type: respBlob.type})
  iFramePath.value = window.URL.createObjectURL(myBlob)
}

function fullScreen() {
  window.open(iFramePath.value)
}
function downloadFile() {
  if (!localFileBlob.value) {return}
  const fileName = uiStore.referenceFile.title
  const fileExtension = uiStore.referenceFile.fileExtension
  gen.downloadBlob(localFileBlob.value, fileName, fileExtension)
}

function printFile() {
  if (!localFileBlob.value) {return}
  const fileType = uiStore.referenceFile.fileType  //"Image" "Pdf"
  gen.printBlob(localFileBlob.value, fileType)
}

// SEARCH BOX
const inputBarContent = ref("")

function changeSearchKeywords() {
  const keywords = uiStore.referenceSearchKeywords
  if (!keywords) return;
  inputBarContent.value = keywords
  uiStore.setReferenceSearchKewords("")
}

function searchFCT(el) {
  //Create path
  const terms = inputBarContent.value
  const path = getSearchEnginePath(el, terms)
  //Open
  if (el.iFramable) {
    uiStore.setReferenceFile(null)
    uiStore.setReferenceIFramePath(path)
  } else {
    window.open(path)
  }
}


watch(
  () => uiStore.referenceSearchKeywords,
  () => {
    changeSearchKeywords()
  },
  { immediate: true }
)

watch(
  () => [
    uiStore.referenceIFramePath,
    uiStore.referenceFile
  ],
  () => {
    setIframePath()
  },
  { immediate: true }
)


</script>

<style scoped>
</style>